import { useEffect, useState } from "react";

export default function Toast({ message, type = "success", duration = 3000, onClose }) {
  const [show, setShow] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(false);
      onClose && onClose();
    }, duration);
    return () => clearTimeout(timer);
  }, [duration, onClose]);

  if (!show) return null;

  const bgClass = type === "success" ? "bg-success" : "bg-danger";

  return (
    <div
      className={`toast align-items-center text-white ${bgClass} border-0 show`}
      role="alert"
      style={{
        position: "fixed",
        top: 20,
        right: 20,
        zIndex: 1055,
        minWidth: 200,
      }}
    >
      <div className="d-flex">
        <div className="toast-body">{message}</div>
        <button
          type="button"
          className="btn-close btn-close-white me-2 m-auto"
          onClick={() => setShow(false)}
        ></button>
      </div>
    </div>
  );
}
